import React, { useEffect } from "react";

import { useStoreServiceApi } from "@api/hooks/storeService.hook";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import { EcornerService } from "@services/eCorner.service";

import ProductFacing from "./productFacing.component";

type Props = {
    sku: string;
};

const ProductFacingContainer = ({ sku }: Props) => {
    const isClientSide = useIsClientSide();
    const [{ data }, get] = useStoreServiceApi(
        {
            url: "/ecorners/:ecornerId/facing/:sku",
            method: "GET",
        },
        {
            manual: true,
        },
    );

    useEffect(() => {
        if (EcornerService.isEcornerEnvironment()) {
            get({
                urlParams: {
                    ecornerId: EcornerService.getEcornerCookie()!,
                    sku: sku,
                },
            });
        }
    }, [isClientSide]);

    if (!data) {
        return null;
    }

    return (
        <ProductFacing
            layer={data.layer}
            subFacingName={data.subFacingName}
            name={data.name}
            position={data.position}
            amountOfPositions={data.amountOfPositions}
        />
    );
};

export { ProductFacingContainer };
